import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';
import PrivateRouting from './PrivateRouting';
import VerifyPage from '../auth/containers/VerifyPage';
import SetupPage from '../auth/containers/SetupPage';
import PublicLayout from "../app/PublicLayout";
import LoginPage from "../auth/containers/LoginPageNew";
import RegisterPage from "../auth/containers/RegisterPageNew";
import { DEFAULT_REFERRER, FIELD_SERVICE_2021_REFERRER } from "../shared/referrers";
import AccountActivation from "../auth/containers/AccountActivation";
import AccountVerified from "../auth/containers/AccountVerified";
import AccountBillingComplete from "../auth/containers/AccountBillingComplete";
import LogoutPage from "../auth/containers/LogoutPage";
import SubscribePage from '../auth/containers/SubscribePage';
import Viewer from '../shared/components/Viewer';
import RestorePasswordPage from '../auth/containers/RestorePasswordPage';
import ChangePasswordPage from '../auth/containers/ChangePasswordPage';

const AppRouting = () => {

  const {
    enableForgotPasswordModule
  } = useFlags();

  return (
    <Switch>
      <Route exact path="/:code([\w-]{4}[-]{1}[\w-]{4})">
        <Viewer />
      </Route>
      <Route exact path="/auth/verify">
        <VerifyPage />
      </Route>
      <Route exact path="/setup/:token">
        <SetupPage />
      </Route>
      <Route exact path={['/login', '/register', '/account-welcome', '/account-verified', '/account-billing-complete', '/fieldservice2021', '/logout', '/setup-subscription', '/password/retrieval', '/password/change']}>
        <PublicLayout>
          <Route exact path="/login">
            <LoginPage/>
          </Route>
          <Route exact path="/register">
            <RegisterPage referrer={DEFAULT_REFERRER}/>
          </Route>
          <Route exact path="/fieldservice2021">
            <RegisterPage referrer={FIELD_SERVICE_2021_REFERRER}/>
          </Route>
          <Route exact path="/account-welcome">
            <AccountActivation/>
          </Route>
          <Route exact path="/account-verified">
            <AccountVerified/>
          </Route>
          <Route exact path="/account-billing-complete">
            <AccountBillingComplete/>
          </Route>
          <Route exact path="/logout">
            <LogoutPage/>
          </Route>
          <Route exact path="/setup-subscription">
            <SubscribePage />
          </Route>
          {
            enableForgotPasswordModule ? (
              <>
                <Route exact path="/password/retrieval">
                  <RestorePasswordPage />
                </Route>
                <Route exact path="/password/change">
                  <ChangePasswordPage />
                </Route>
              </>
            ) : null
          }
        </PublicLayout>
      </Route>
      <PrivateRouting />
    </Switch>
  );
};

export default AppRouting;
